<button mat-mini-fab [color]="color" aria-label="Refresh button" (click)="doRefresh()">
  <mat-icon>refresh</mat-icon>
</button>
